import React from 'react';
import { Link } from 'react-router-dom';

interface PageTitleProps {
  title: string;
  description: string;
  breadcrumbs: Array<{ name: string; path?: string }>;
  image?: string;
  imageAlt?: string;
  imageQuote?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ title, description, breadcrumbs, image, imageAlt, imageQuote }) => {
  return (
    <div className="page-title" data-aos="fade">
      <div className="heading">
        <div className="container">
          <div className="row d-flex justify-content-center text-center">
            <div className="col-lg-8">
              <h1>{title}</h1>
              {imageQuote && (
                <p 
                  className="image-quote page-title-quote" 
                  style={{
                    fontSize: '1.1rem',
                    fontWeight: '500',
                    fontStyle: 'italic',
                    color: 'var(--default-color)',
                    margin: '15px auto 10px',
                    maxWidth: '700px',
                    lineHeight: '1.5',
                    whiteSpace: 'normal'
                  }}
                >
                  {imageQuote}
                </p>
              )}
              {image && (
                <div className="page-title-image" style={{
                  margin: '20px 0',
                  display: 'flex',
                  justifyContent: 'center'
                }}>
                  <img 
                    src={image} 
                    alt={imageAlt || 'Quote image'} 
                    style={{
                      maxWidth: '230px',
                      height: 'auto',
                      borderRadius: '10px',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                      
                    }}
                  />
                </div>
              )}
              <p 
                className="mb-0 page-title-description" 
                style={{
                  whiteSpace: 'pre-line',
                  fontSize: '1.25rem',
                  fontWeight: '500',
                  lineHeight: '1.6',
                  fontStyle: 'italic',
                  color: 'var(--accent-color)',
                  textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                  maxWidth: '600px',
                  margin: '0 auto'
                }}
              >
                {description}
              </p>
            </div>
          </div>
        </div>
      </div>
      <nav className="breadcrumbs">
        <div className="container">
          <ol>
            {breadcrumbs.map((breadcrumb, index) => (
              <li key={index} className={index === breadcrumbs.length - 1 ? 'current' : ''}>
                {breadcrumb.path ? (
                  <Link to={breadcrumb.path}>{breadcrumb.name}</Link>
                ) : (
                  breadcrumb.name
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>
    </div>
  );
};

export default PageTitle; 